// extracted by mini-css-extract-plugin
export default {"root":"_1Dtsy","image":"_1_09Q","large":"_1PyrA","medium":"_3yHrm","small":"C06Mn"};